import { useIsIOSApp } from '@/hooks/useIsIOSApp';

const APPLE_URL = 'https://apps.apple.com/cy/app/expatssphere/id6759835992';
const GOOGLE_URL = 'https://play.google.com/store/apps/details?id=com.expatssphere.twa';

/**
 * App Store badge SVGs — inline for reliability (no external image dependencies).
 * Hidden when user is already inside the installed app.
 */
export default function AppStoreBadges({ className = '', size = 'md' }) {
  const isInstalledApp = useIsIOSApp() || 
    (typeof window !== 'undefined' && window.matchMedia('(display-mode: standalone)').matches);

  if (isInstalledApp) return null;

  const h = size === 'sm' ? 'h-9' : size === 'lg' ? 'h-12' : 'h-10';

  return (
    <div className={`flex flex-wrap items-center gap-3 ${className}`} data-testid="app-store-badges">
      <a
        href={APPLE_URL}
        target="_blank"
        rel="noopener noreferrer"
        aria-label="Download on the App Store"
        data-testid="apple-store-badge"
      >
        <img
          src="https://tools.applemediaservices.com/api/badges/download-on-the-app-store/black/en-us?size=250x83"
          alt="Download on the App Store"
          className={`${h} w-auto`}
        />
      </a>
      <a
        href={GOOGLE_URL}
        target="_blank"
        rel="noopener noreferrer"
        aria-label="Get it on Google Play"
        data-testid="google-play-badge"
      >
        <img
          src="https://play.google.com/intl/en_us/badges/static/images/badges/en_badge_web_generic.png"
          alt="Get it on Google Play"
          className={`${h} w-auto`}
        />
      </a>
    </div>
  );
}
